module.exports = __webpack_public_path__ + "static/AirPlay-04dc9ba41ca718f14aeb1d16ea89ec2b.png";